import React from 'react'

function Gform() {
  return (
    <div style={{background: "linear-gradient(to right, #1e2464, #090a1f)"}}>
    <div></div>
      {/* <iframe src="https://forms.gle/VM9egpYXPSvBLoqf9" width="100%" height="1541" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> */}
      <iframe src="https://docs.google.com/forms/d/e/1FAIpQLSfYG3oBC2Yx3VavQcjUlAHg6GrcMRIfdd2aSAcsf13hnJNjDg/viewform?embedded=true" width="100%" height="2216" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
    </div>
  )
}

export default Gform
